"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTextarea = exports.Base = exports.styles = exports.STYLE = exports.CONFIG = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("../../../../theme");
var typography_1 = require("../../../typography");
exports.CONFIG = {
    small: {
        height: 44,
    },
    medium: {
        height: 44,
    },
    large: {
        height: 48,
    },
};
exports.STYLE = {
    border: {
        radius: '10px',
        width: '1px',
        color: theme_1.theme.colors.GREY_60,
    },
    padding: '0 16px',
};
exports.styles = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  display: block;\n  /* line-height: ", "; */\n  padding: 0 ", "px;\n  line-height: inherit;\n\n  width: ", ";\n  max-width: 100%;\n  height: ", "px;\n\n  @media ", " {\n    height: ", "px;\n  }\n\n  @media ", " {\n    height: ", "px;\n  }\n\n  &::placeholder {\n    color: ", ";\n    font: inherit;\n    line-height: revert;\n  }\n\n  ", " {\n    &:hover {\n      border-color: ", ";\n    }\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  display: block;\n  /* line-height: ", "; */\n  padding: 0 ", "px;\n  line-height: inherit;\n\n  width: ", ";\n  max-width: 100%;\n  height: ", "px;\n\n  @media ", " {\n    height: ", "px;\n  }\n\n  @media ", " {\n    height: ", "px;\n  }\n\n  &::placeholder {\n    color: ", ";\n    font: inherit;\n    line-height: revert;\n  }\n\n  ", " {\n    &:hover {\n      border-color: ", ";\n    }\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? theme_1.theme.colors.GREY_10 : theme_1.theme.colors.WHITE);
}, theme_1.theme.colors.GREY_90, exports.STYLE.border.width, function (_a) {
    var error = _a.error;
    return (!!error ? theme_1.theme.colors.RED_50 : exports.STYLE.border.color);
}, exports.STYLE.border.radius, 1, 16, function (_a) {
    var $width = _a.$width;
    return ($width ? $width + "em" : '100%');
}, exports.CONFIG.small.height, theme_1.theme.breakpoints.medium, exports.CONFIG.medium.height, theme_1.theme.breakpoints.large, exports.CONFIG.large.height, theme_1.theme.colors.GREY_50, theme_1.theme.utils.canHover, function (_a) {
    var disabled = _a.disabled, error = _a.error;
    return (!!error || disabled ? '' : theme_1.theme.colors.GREY_70);
}, theme_1.theme.colors.BLUE_50);
exports.Base = styled_components_1.default(typography_1.Body).attrs({ level: '3', forwardedAs: 'input' })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.styles);
exports.BaseTextarea = styled_components_1.default(typography_1.Body).attrs({ level: '3', forwardedAs: 'textarea' })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  padding-top: 0.7em;\n  padding-bottom: 0.7em;\n  height: ", ";\n"], ["\n  ", "\n\n  padding-top: 0.7em;\n  padding-bottom: 0.7em;\n  height: ", ";\n"])), exports.styles, function (_a) {
    var $height = _a.$height;
    return ($height ? $height + "em!important;" : '');
});
var templateObject_1, templateObject_2, templateObject_3;
